




import {Component, Prop, Vue} from 'vue-property-decorator';
import CalendarIcon from 'vue-material-design-icons/CalendarRange.vue';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import PhoneIcon from 'vue-material-design-icons/Phone.vue';
import PersonIcon from '@/shared/icons/PersonIcon.vue';
import TextIcon from 'vue-material-design-icons/TextShort.vue';
import DecimalIcon from 'vue-material-design-icons/CurrencyGbp.vue';
import CustomAttributeIcon from '@/shared/icons/CustomAttributeIcon.vue';
import QuestionIcon from 'vue-material-design-icons/ForumOutline.vue';
import NumberIcon from 'vue-material-design-icons/Pound.vue';
import PageIcon from 'vue-material-design-icons/Earth.vue';


@Component({
	components: {
		CalendarIcon,
		PersonIcon,
		EmailIcon,
		PhoneIcon,
		TextIcon,
		DecimalIcon,
		CustomAttributeIcon,
		QuestionIcon,
		NumberIcon,
		PageIcon
	}
})
export default class DataTableIcon extends Vue {
	@Prop() public icon: string;

}
